import { render } from "./ModalConfirmacao.vue?vue&type=template&id=714464e8&scoped=true"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js"

import "./ModalConfirmacao.vue?vue&type=style&index=0&id=714464e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714464e8"]])

export default __exports__